import { googleClient } from '@service-initiation/shared-clients-google';
import { logger } from '@service-initiation/shared-clients-osp-logger';

export const getPlacePredictions = async (
  input: string,
  options?: Partial<google.maps.places.AutocompletionRequest>
) => {
  try {
    return await (
      await googleClient
    ).autocomplete.getPlacePredictions({
      componentRestrictions: { country: ['US', 'TT'] },
      input,
      sessionToken: (await googleClient).sessionToken,
      types: ['(regions)'],
      ...(options ? options : {}),
    });
  } catch (e) {
    const err = e as Error;
    err.message = 'Failed to get place predictions';
    logger.error(err);
    throw err;
  }
};
